import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=8e4e1a4c&scoped=true&"
import script from "./Commodity.vue?vue&type=script&lang=js&"
export * from "./Commodity.vue?vue&type=script&lang=js&"
import style0 from "./Commodity.vue?vue&type=style&index=0&id=8e4e1a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4e1a4c",
  null
  
)

export default component.exports